import { BasicRuntimeFormControl } from "components/Forms/BasicRuntimeFormField/BasicRuntimeFormField.tsx";
import { FieldWrapper } from "components/UI/Table/UI/InteractiveCell/components/FieldWrapper.tsx";
import { FC } from "react";
import { useFormState, useWatch } from "react-hook-form";

import FormFieldData = App.Data.FormFieldData;

interface RuntimeFormFieldCellProps {
    field: FormFieldData;
    editable: boolean;
    alwaysEditing?: boolean;
}

const displayValue = (value: unknown): string | readonly string[] | number | null => {
    if (Array.isArray(value)) return value.map(String);
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (typeof value === "number" || typeof value === "string") return value;
    return null;
};

export const RuntimeFormFieldCell: FC<RuntimeFormFieldCellProps> = ({ field, editable, alwaysEditing = false }) => {
    const name = `fields.${field.system_name}`;
    const value = useWatch({ name });
    const { errors } = useFormState({ name });
    const fieldErrors = errors.fields as Record<string, { message?: unknown }> | undefined;
    const error = fieldErrors?.[field.system_name];

    if (alwaysEditing) {
        return <BasicRuntimeFormControl field={field} name={name} />;
    }

    if (!editable) {
        const resolved = displayValue(value);
        return <span>{Array.isArray(resolved) ? resolved.join(", ") : (resolved ?? "-")}</span>;
    }

    return (
        <FieldWrapper
            displayValue={displayValue(value)}
            isError={!!error}
            errorMessage={typeof error?.message === "string" ? error.message : undefined}
        >
            <div className="rounded border bg-white p-2">
                <BasicRuntimeFormControl field={field} name={name} />
            </div>
        </FieldWrapper>
    );
};
